let initialized = false

export const initSentry = async () => {
  const dsn = import.meta.env.VITE_SENTRY_DSN

  if (!dsn || initialized) {
    return
  }

  try {
    const Sentry = await import('@sentry/react')
    Sentry.init({
      dsn,
      environment: import.meta.env.MODE,
      tracesSampleRate: Number(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE) || 0.1
    })
    initialized = true
  } catch (err) {
    console.warn('[sentry] Failed to initialize:', err.message)
  }
}
